_ = require 'underscore'
{ TrelloStorage } = require '@trello/storage'
{ verticals } = require 'app/scripts/views/onboarding/constants'

getSavedInspirationBoards = =>
  TrelloStorage.get("inspiration-boards") || {}

isInspirationBoard = (boardId) =>
  savedInspoBoards = getSavedInspirationBoards()
  for inspoBoardId, myBoardId of savedInspoBoards
    return true if myBoardId == boardId
  return false

getInspoBoardId = (boardId) =>
  savedInspoBoards = getSavedInspirationBoards()
  for inspoBoardId, myBoardId of savedInspoBoards
    return inspoBoardId if myBoardId == boardId

getVertical = (boardId) =>
  thisInspoBoardId = getInspoBoardId(boardId)
  for vertical, def of verticals
    for lang, board of def.inspirationBoards
      return vertical if board.id == thisInspoBoardId
  return null

saveBoard = (id, boardId) =>
  savedInspoBoards = getSavedInspirationBoards()

  TrelloStorage.set("inspiration-boards", _.extend {}, savedInspoBoards, {
    "#{id}": boardId
  })

removeBoard = (boardId) =>
  savedInspoBoards = getSavedInspirationBoards()
  for inspoBoardId, myBoardId of savedInspoBoards
    if myBoardId == boardId
      delete savedInspoBoards[inspoBoardId]
      TrelloStorage.set('inspiration-boards', savedInspoBoards)

module.exports = {
  isInspirationBoard
  removeBoard
  getVertical
  getInspoBoardId
  getSavedInspirationBoards
  saveBoard
}
